<div class="relative h-full max-w-4xl mx-auto p-4 rounded-l flex flex-col justify-between overflow-y-auto">
  <div class="flex flex-col">
    <!-- Header -->
    <div class="flex items-center justify-between p-4 border-b border-gray-200">
      <button (click)="clearHistory()" class="text-gray-500 hover:text-gray-700 cursor-pointer" title="Limpiar historial">
        <mat-icon >delete</mat-icon>
      </button>
      <button (click)="closeChat()" class="text-gray-500 hover:text-gray-700 cursor-pointer">
        <mat-icon >close</mat-icon>
      </button>
    </div>

    <!-- Terms of Use -->
    <div class="p-4 text-center text-sm text-gray-600 border-b border-gray-200">
      <h2 class="font-semibold mb-2">Términos de Uso</h2>
      <p>
        Este es un chatbot de IA generativa <span class="font-Lato-Bold">EXPERIMENTAL</span>. Al interactuar con él, aceptas los
        <a href="/contents/terms" class="text-[#FF6D03] hover:underline ml-1">
          Términos de Uso
        </a>
        y la
        <a href="/contents/politica-privacidad" class="text-[#FF6D03] hover:underline ml-1">
          Política de Privacidad
        </a>
        de Katapulk.
      </p>
    </div>

    <!-- Messages Container -->
    <div class="bg-gray-50 p-4">
      <app-chat-message
        *ngFor="let message of messages"
        [message]="message"
        [accentColor]="accentColor">
      </app-chat-message>
      <div #messagesEnd></div>
    </div>

  </div>

  <!-- Input Form -->
  <div class="pb-16">
    <form (submit)="handleSubmit($event)" class="p-4 pr-16 border-t border-gray-200">
      <div class="flex items-center">
        <textarea
          type="text"
          placeholder="Haz una pregunta"
          [(ngModel)]="inputValue"
          (input)="handleInputChange($event)"
          name="chatInput"
          class="w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:border-transparent">
        </textarea>
        <div class="flex items-baseline">
          <button
            type="submit"
            class="text-yellow-#FF6D03 hover:text-[#e56200] p-1 rounded-md disabled:text-yellow-#FFA101"
            [disabled]="!inputValue.trim()"
          >
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
      <p class="text-xs text-gray-500 mt-2">
        Este es un chatbot experimental de IA generativa. Toda la información debe ser verificada.
      </p>
    </form>

    <!-- Suggested Prompts -->
    <div class="p-4 border-t border-gray-200" *ngIf="messages.length < 2">
      <p class="text-sm text-gray-600 mb-2">Preguntas Sugeridas</p>
      <div class="flex flex-wrap gap-2">
        <app-suggested-prompt
          *ngFor="let prompt of suggestedPrompts"
          [text]="prompt"
          [accentColor]="accentColor"
          [disabledColor]="disabledColor"
          (onClick)="handlePromptClick(prompt)">
        </app-suggested-prompt>
      </div>
    </div>
  </div>
</div>
